import { Box, Container, Flex, Text, Link } from '@chakra-ui/react';

const Footer = () => {
  return (
    <Box as="footer" py={8} bg="gray.900" color="white">
      <Container maxW="container.xl">
        <Flex justify="space-between" align="center">
          <Text>&copy; {new Date().getFullYear()} Graham Cracker Studios. All rights reserved.</Text>
          <Flex gap={5}>
            <Link href="https://twitter.com" target="_blank" color="rgba(255, 255, 255, 0.8)" _hover={{ color: 'white' }}>
              Twitter
            </Link>
            <Link href="https://www.grahamcrackerstudios.com/positions" color="rgba(255, 255, 255, 0.8)" _hover={{ color: 'white' }}>
              Positions
            </Link>
            <Link href="#" target="_blank" color="rgba(255, 255, 255, 0.8)" _hover={{ color: 'white' }}>
              Soon!
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;